<template>
  <div class="aggregation-correction-report-tbl pl-3 pb-2">
    <v-data-table
      :headers="table.headers"
      :items="reportLayout.dataSeriesTbl"
      :items-per-page="pagination.itemsPerPage"
      @pagination="PAGINATION = $event"
      :page.sync="pagination.page"
      :loading="table.loading"
      :loading-text="$t('tableText.loadingText')"
      class="elevation-1 mt-1"
      :class="tblClassColor"
      :no-results-text="$t('tableText.noResultsText')"
      :no-data-text="$t('tableText.noDataText')"
      hide-default-header
      hide-default-footer
      fixed-header
      dense
    >
      <template v-slot:no-data>
        <td colspan="12" class="text-center">
          {{ $t("tableText.noDataText") }}
        </td>
      </template>

      <template v-slot:item="{ item, index }">
        <!-- AGGREGATION ROW -->
        <tr
          style="cursor: grabbing"
          v-if="index < 2"
          :class="item.isRowBelow ? 'row-data-below' : ''"
        >
          <td colspan="2" class="text-center b-1-g mw-100"></td>
          <td
            v-for="(subHeader, idx) in table.subHeaders"
            :idx="`rp-4-row-data-${idx}`"
            :key="`rp-4-row-data-${idx}`"
            class="text-right b-1-g mw-100"
          >
            {{ item[`${subHeader.value}`] }}
          </td>
        </tr>
        <!-- SECOND HEADER ROW -->
        <tr style="cursor: grabbing" v-if="index === 2">
          <th class="text-center b-1-g mw-100">
            {{ item.majorCode }}
          </th>
          <th class="text-center b-1-g mw-100">
            {{ item.middleCode }}
          </th>
          <th
            v-for="(subHeader, idx) in table.subHeaders"
            :idx="`rp-4-row-data-${idx}`"
            :key="`rp-4-row-data-${idx}`"
            class="text-center b-1-g mw-100 second-header-tbl"
          >
            {{ subHeader.text }}
          </th>
        </tr>

        <!-- DATA ROW -->
        <tr style="cursor: grabbing" v-if="index > 2">
          <td v-if="item.isRowBelow" class="text-left b-1-g mw-100"></td>
          <td v-else class="text-left b-1-g mw-100">
            {{ item.majorCode }} {{ item.majorNameKanji }}
          </td>
          <td class="text-left b-1-g mw-100"></td>
          <td
            v-for="(subHeader, idx) in table.subHeaders"
            :idx="`rp-4-row-data-${idx}`"
            :key="`rp-4-row-data-${idx}`"
            :class="item.isRowBelow ? 'row-data-below' : ''"
            class="text-right b-1-g mw-100"
          >
            {{ item[`${subHeader.value}`] }}
          </td>
        </tr>
      </template>

      <!-- HEADER -->
      <template v-slot:header="{ props }" v-if="table.subHeaders.length > 0">
        <thead class="border-header-tbl">
          <tr>
            <th rowspan="2" colspan="2">
              {{ request.storeCode }} - 千葉轟町店
            </th>
            <th class="text-center" rowspan="1" :colspan="supHeaderColSpan">
              {{ timeSelected }}
            </th>
          </tr>
          <tr>
            <th
              v-for="(subHeader, idx) in table.subHeaders"
              :idx="`rp-4-sub-header-${idx}`"
              class="rp-4-sub-header"
              colspan="1"
              rowspan="1"
              :key="`rp-4-key-sub-header-${idx}`"
            >
              {{ subHeader.text }}
            </th>
          </tr>
        </thead>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  PAGINATION,
  AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES,
  REPORT_4_TBL_TYPE,
} from "@/common/constant";

export default {
  name: "AggregationCorrectionReportTbl",
  props: {
    request: {
      type: Object,
      require: true,
    },
    reportLayout: {
      type: Object,
      require: true,
    },
    pagination: {
      type: Object,
      require: true,
    },
    selectedDate: {
      type: Object,
      require: true,
    },
    tblTypeId: {
      type: Number,
      require: true,
    },
    tblClassColor: {
      type: String,
      require: false,
      default: "primary-tbl",
    },
  },
  computed: {
    supHeaderColSpan() {
      return this.reportLayout.reportIds.length;
    },
    timeSelected() {
      switch (this.tblTypeId) {
        case REPORT_4_TBL_TYPE.BEFORE.id:
          return `BEFORE：${this.request.referenceStartDate} ~ ${this.request.referenceEndDate}`;
        case REPORT_4_TBL_TYPE.AFTER.id:
          return `AFTER:${this.request.compareStartDate} ~ ${this.request.compareEndDate}`;
        default:
          return "";
      }
    },
  },
  data() {
    return {
      AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES:
        AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES,
      REPORT_4_TBL_TYPE: REPORT_4_TBL_TYPE,
      table: {
        PAGINATION: PAGINATION,
        headers: [],
        subHeaders: [],
      },
    };
  },
  methods: {
    getCustomHeaders() {
      this.table.subHeaders = [];
      this.reportLayout.reportIds.forEach((id) => {
        this.table.subHeaders.push({
          text: AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES[`${id - 1}`].text,
          value:
            AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES[`${id - 1}`].property,
        });
      });

      console.log("this.table.subHeaders", this.table.subHeaders);
    },
  },
  created() {
    this.getCustomHeaders();
  },
};
</script>

<style lang="scss">
.aggregation-correction-report-tbl {
  .v-data-table__wrapper {
    width: calc(100vw - 118px) !important;
  }
  .primary-tbl {
    .border-header-tbl {
      th {
        border: 0.1px solid rgba(255, 255, 255, 0.5) !important;
        text-align: center !important;
        background: #1976d2 !important;
        color: white !important;
        min-width: 100px !important;
      }
    }
    .second-header-tbl {
      border: 0.1px solid rgba(255, 255, 255, 0.5) !important;
      text-align: center !important;
      background: #1976d2 !important;
      color: white !important;
      min-width: 100px !important;
    }
  }

  .warning-tbl {
    .border-header-tbl {
      th {
        border: 0.1px solid rgba(255, 255, 255, 0.5) !important;
        text-align: center !important;
        background: #fb8c00 !important;
        color: white !important;
        min-width: 100px !important;
      }
    }
    .second-header-tbl {
      border: 0.1px solid rgba(255, 255, 255, 0.5) !important;
      text-align: center !important;
      background: #fb8c00 !important;
      color: white !important;
      min-width: 100px !important;
    }
  }

  .success-tbl {
    .border-header-tbl {
      th {
        border: 0.1px solid rgba(255, 255, 255, 0.5) !important;
        text-align: center !important;
        background: #4caf50 !important ;
        color: white !important;
        min-width: 100px !important;
      }
    }
    .second-header-tbl {
      border: 0.1px solid rgba(255, 255, 255, 0.5) !important;
      text-align: center !important;
      background: #4caf50 !important;
      color: white !important;
      min-width: 100px !important;
    }
  }
  .row-data-below {
    color: red !important;
  }
}
</style>
